module.exports = __webpack_public_path__ + "img/drivingPermits.362fa71d.png";